import { useEffect, useState } from 'react';
import useAxiosWithAuth from '../api/useAxiosWithAuth';

const useExportersQuery = () => {
    const [exporters, setExporters] = useState([]);
    const [loading, setLoading] = useState(false);

    const axiosInstance = useAxiosWithAuth();

    useEffect(() => {
        const fetchLocations = async () => {
            setLoading(true);

            try {
                const { data, status } = await axiosInstance.get('/trade/exporter-name?page_size=15000&page_number=1');

                if (status === 200) {
                    const formatted = data.payload.map((exporter) => ({
                        value: exporter.name,
                        label: exporter.name,
                    }));

                    setExporters(formatted);
                } else {
                    setExporters([]);
                }
            } catch (err) {
                console.error('Error fetching exporter names:', err);
                setExporters([]);
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, []);

    return { exporters, loading };
};

export default useExportersQuery;
